import { SiteEmbedIframePreview } from "@/components/features-new/settings-external-connection/site-embed/site-embed-preview";

import { VARIANT_LABEL_JA } from "./site-embed-settings-constants";

import type { LangType, SiteEmbedVariant } from "../site-embed-preview/types";


const PREVIEW_NOTICE_TEXT =
	"こちらのプレビューではクレジットカード決済はできません。決済の最終確認は埋め込み先のサイトで行ってください。";

type Props = {
	hotelID: string;
	variant: SiteEmbedVariant;
	lang: LangType;
	previewLangBadgeLabel: string;
	layout: "mobile" | "desktop";
};

export const SiteEmbedSettingsPreview = ({
	hotelID,
	variant,
	lang,
	previewLangBadgeLabel,
	layout,
}: Props) => {
	const statusBadges = (
		<div className="flex shrink-0 flex-wrap items-center gap-2 text-xs text-zinc-600">
			<span className="rounded-full border border-zinc-300 bg-white px-2 py-1">
				埋め込み形式: {VARIANT_LABEL_JA[variant]}
			</span>
			<span className="rounded-full border border-zinc-300 bg-white px-2 py-1">
				表示言語: {previewLangBadgeLabel}
			</span>
		</div>
	);

	if (layout === "mobile") {
		return (
			<div className="space-y-3 rounded-xl border border-zinc-100 bg-white p-4">
				{statusBadges}
				<p className="text-xs text-amber-700">{PREVIEW_NOTICE_TEXT}</p>
				<div className="min-h-[420px] rounded-md bg-white p-2">
					<SiteEmbedIframePreview hotelID={hotelID} variant={variant} lang={lang} />
				</div>
				<p className="text-xs text-zinc-500">
					上の埋め込み形式・言語の設定で、自社サイトに近い見え方を確認できます。
				</p>
			</div>
		);
	}

	return (
		<div className="flex min-h-0 w-full min-w-0 flex-1 flex-col gap-3">
			{statusBadges}
			<p className="shrink-0 text-xs text-amber-700">{PREVIEW_NOTICE_TEXT}</p>
			<div className="flex min-h-0 flex-1 flex-col overflow-y-auto rounded-md bg-white p-2">
				<SiteEmbedIframePreview fillHeight hotelID={hotelID} variant={variant} lang={lang} />
			</div>
		</div>
	);
};
